import React, { LegacyRef } from 'react';
import { TotalsProgressBar } from '../ActivityTotals/TotalsProgressBar/TotalsProgressBar';
import CompactPageOwnerAvatarStory from '../CompactPageOwnerStory/CompactPageOwnerAvatarStory';
import TruncatedPageOwnerTitle from '../PageOwnerTitle/PageTitle';
import styles from './InstagramShareScreenshot.scss';
import { PAGES_UI_FEATURE_IMAGE } from '../../constants/imageTemplateStrings';
import { JustGivingLogo } from '../JustGivingLogo/JustGivingLogo';
import classNames from 'classnames';

export enum IG_SHARE_TYPE {
  POST,
  STORY,
}

interface InstagramShareScreenshotProps {
  heroImageUrl: string;
  altText: string;
  screenshotRef: LegacyRef<HTMLDivElement>;
  className?: string;
  type: IG_SHARE_TYPE;
}

export const InstagramShareScreenshot: React.FunctionComponent<InstagramShareScreenshotProps> = ({
  heroImageUrl,
  altText,
  screenshotRef,
  className,
  type,
}) => {
  const isStory = type === IG_SHARE_TYPE.STORY;

  return (
    <div style={{ height: '0', overflow: 'hidden' }} id="container" aria-hidden>
      <div
        className={isStory ? styles.storyContainer : styles.container}
        ref={screenshotRef}
      >
        <div
          className={classNames(
            styles.shareContainer,
            isStory
              ? styles.shareContainer__story
              : styles.shareContainer__post,
          )}
        >
          <div className={styles.imageAndLogo}>
            <div className={styles.logo} id="logo">
              <JustGivingLogo />
            </div>
            <div className={styles.imageContainer}>
              <img
                src={`${heroImageUrl}?template=${PAGES_UI_FEATURE_IMAGE}`}
                alt={altText}
                className={classNames(styles.shareModalImage)}
              />
            </div>
          </div>
          <div className={styles.shareTextAndTotals}>
            <div>
              <TruncatedPageOwnerTitle
                truncateAt={90}
                className={styles.pageTitle}
                variant={'screenshot'}
              />
            </div>
            <div>
              <CompactPageOwnerAvatarStory linkToFrp={false} />
              <TotalsProgressBar isInstagramShare={true} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
